import { X } from 'lucide-react';

export function Drawer({ open, title, eyebrow, description, onClose, children, width = 'max-w-xl', actions }) {
  if (!open) return null;
  return <div className="fixed inset-0 z-[70] overflow-hidden">
    <button type="button" aria-label="Close drawer" className="absolute inset-0 bg-black/65 backdrop-blur-[3px]" onClick={onClose}/>
    <aside className={`absolute inset-y-0 right-0 flex w-full ${width} flex-col border-l border-cyan-300/15 bg-[#07101a] shadow-[-24px_0_80px_rgba(0,0,0,.55)]`}>
      <header className="flex min-h-14 shrink-0 items-center gap-3 border-b border-white/8 px-4">
        <div className="min-w-0 flex-1">
          {eyebrow && <p className="truncate text-[7px] font-black uppercase tracking-[.18em] text-cyan-300/70">{eyebrow}</p>}
          <h2 className="truncate text-[15px] font-black text-slate-100">{title}</h2>
          {description && <p className="truncate text-[9px] text-slate-600">{description}</p>}
        </div>
        {actions}
        <button type="button" onClick={onClose} className="grid size-8 place-items-center border border-white/10 text-slate-500 transition hover:border-cyan-300/30 hover:text-cyan-100"><X size={15}/></button>
      </header>
      <div className="scrollbar min-h-0 flex-1 overflow-y-auto p-4">{children}</div>
    </aside>
  </div>;
}
